import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useConfig } from "@/composables/config";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridOperations',
    props: {
        rowData: null,
        operations: null,
        title: null
    },
    emits: ["execute"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown);
        const { config, isConfigLoaded } = useConfig();
        /**
         * Availibility of operations might required certain conditions
         */
        function hasCondition(conditionHandler) {
            return conditionHandler ? conditionHandler(props.rowData, config) : true;
        }
        return { __sfc: true, config, isConfigLoaded, props, emit, hasCondition, FontAwesomeIcon };
    }
});
